const isWindowExists = () => typeof window !== 'undefined';

const triggerLifeCycleEvent = (eventName, payload) => {
  if (!isWindowExists() || !window.LIFE_CYCLE_EVENT_BUS?.trigger) {
    return;
  }

  if (payload !== undefined && payload !== null) {
    window.LIFE_CYCLE_EVENT_BUS.trigger(eventName, payload);
    return;
  }

  window.LIFE_CYCLE_EVENT_BUS.trigger(eventName);
};

export default triggerLifeCycleEvent;
